<template>
  <section>
    <b-container fluid>
      <b-row align-v="start" class="section-title">
        <b-col cols="12" lg="10" offset-lg="1" xl="8" offset-xl="2">
          <h2>Administration des comptes utilisateurs</h2>
        </b-col>
      </b-row>
      <b-row align-v="center" class="section-content">
        <b-col cols="12" sm="10" offset-sm="1" md="8" offset-md="2">
          <b-card v-if="allUsers && allUsers.totalCount > 0">
            <b-pagination
              align="center"
              size="md"
              :total-rows="allUsers.totalCount"
              v-model="currentPage"
              :per-page="nbUserPerPage"
              @change="onPageChange"
            ></b-pagination>
            <b-list-group>
              <b-list-group-item
                v-for="user in allUsers.data"
                :key="user.id"
                class="container-fluid pull-right mb-2"
              >
                <a :href="`/profile/${user.id}`" target="_blank" class="pull-left">
                  <img
                    :src="user.picture"
                    alt="Photo de profil"
                    width="42"
                    height="42"
                    class="rounded-circle m-2"
                  >
                  {{ user.username }} ({{ user.firstname }} {{ user.lastname }} {{ user.email }})
                </a>
                <b-button
                  class="pull-right m-2 p-2"
                  variant="danger"
                  size="md"
                  title="Supprimer le profil"
                  v-confirm="{
                            loader: true,
                            okText: 'Confirmer',
                            cancelText: 'Annuler',
                            ok: dialog => onDeleteUser(dialog, user.id),
                            message: 'Souhaitez-vous vraiment supprimer cet utilisateur?',
                            type: 'hard',
                            verification: 'ok',
                            verificationHelp: `Entrez « ok » ci-dessous pour confirmer`,
                          }"
                >
                  Supprimer
                  <i class="fa fa-times fa-fw"></i>
                </b-button>
                <b-button
                  :href="`/settings/${user.id}`"
                  target="_blank"
                  class="pull-right m-2 p-2"
                  variant="primary"
                  size="md"
                >
                  Paramètres
                  <i class="fa fa-cog fa-fw"></i>
                </b-button>
                <b-button
                  :href="`/profile/${user.id}`"
                  target="_blank"
                  class="pull-right m-2 p-2"
                  variant="primary"
                  size="md"
                >
                  Voir le profil
                  <i class="fa fa-eye fa-fw"></i>
                </b-button>
              </b-list-group-item>
            </b-list-group>
            <b-pagination
              align="center"
              size="md"
              :total-rows="allUsers.totalCount"
              v-model="currentPage"
              :per-page="nbUserPerPage"
              @change="onPageChange"
            ></b-pagination>
          </b-card>
          <b-card v-if="allUsers && allUsers.totalCount === 0">Aucun compte utilisateur</b-card>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "Admin",
  data: function() {
    return {
      currentPage: 1,
      nbUserPerPage: 10
    };
  },
  mounted: function() {
    this.getAll({
      userId: this.loggedUser.id,
      page: this.currentPage,
      limit: this.nbUserPerPage,
      sort: "username"
    });
  },
  computed: {
    ...mapState({
      allUsers: state => state.users.all.users,
      loggedUser: state => state.account.user
    })
  },
  watch: {
    current: function(newVal) {
      if (newVal.user.deleted) {
        this.getAll({
          userId: this.loggedUser.id,
          page: this.currentPage,
          limit: this.nbUserPerPage,
          sort: "username"
        });
      }
    }
  },
  methods: {
    ...mapActions("users", ["getAll"]),
    ...mapActions("account", ["destroy"]),
    onPageChange(page) {
      this.currentPage = page;
      this.getAll({
        userId: this.loggedUser.id,
        page: page,
        limit: this.nbUserPerPage,
        sort: "username"
      });
    },
    onDeleteUser(dialog, userId) {
      this.destroy(userId).then(() => dialog.close());
    }
  }
};
</script>
